

import styled from 'styled-components';

export const PopoverButton = styled.div`
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
`
export const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  max-height: 250px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #002e5c46;
    opacity: 0.2;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.2;
    background: #002e5c46;
  }
  
`

export const PopoverActionCol = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.75rem 1.25rem;
    color: #181C32;
    cursor: pointer;
    transition: background-color 0.2s;
    gap: 10px;
    &:hover {
      background-color: #F5F5F5;
    }
`
  
export const PopoverBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 0.42rem;
    border: 1px solid transparent;
    height: 24px;
    width: 24px;
    transition: all 0.3s ease;
    background-color: ${({checked} ) => checked ? '#2555ef' : '#EBEDF3'};

    &::after {
      content: "";
      width: 6px;
      height: 12px;
      border-color: ${({checked} ) => checked ? '#ffffff' : 'transparent'};
      border-style: solid;
      border-width: 0 2px 2px 0!important;
      transform: rotate(45deg);
      margin-top: -2px;
    }
`